import React, { useState, useEffect } from "react";
import {
  getSingleSCTeam,
  selectSingleSCTeam,
  selectLoading,
} from "../state/reducers/SCTeamsReducer";
import { TableContainer } from "@mui/material";
import PlayerDataGrid from "../components/DataGrid/PlayerDataGrid";
import RoundSelector from "../components/Inputs/RoundSelector";
import PlayerOwnershipsContainer from "../components/SingleSCTeam/PlayerOwnershipsContainer";
import RankGraph from "../components/SingleSCTeam/RankGraph";
import SingleSCTeamHeader from "../components/SingleSCTeam/SingleSCTeamHeader";
import { Placing } from "../types/types";
import { PageContainer } from "../globals/styles";
import Header from "../components/Header/Header";
import { useAppDispatch, useAppSelector } from "../hooks";
import { useParams } from "react-router-dom";
import Loading from "../components/Loading";
import { RegisterPageView } from "../globals/Analytics";

const SingleSCTeam = () => {
  const dispatch = useAppDispatch();
  let { teamid } = useParams<{ teamid: string }>();
  const [done, setDone] = useState(false);

  useEffect(() => {
    dispatch(getSingleSCTeam(teamid));
    RegisterPageView({ path: `/singlescteam/${teamid}` });
  }, [teamid]);

  const theTeam = useAppSelector(selectSingleSCTeam);
  const isloading = useAppSelector(selectLoading);
  useEffect(() => {}, [isloading]);

  const placings = theTeam ? theTeam["placings"] : [];

  const playerOwnerships = theTeam ? theTeam["playerOwnerships"] : [];
  const lastplacing: Placing =
    placings.length > 1
      ? placings[placings.length - 1]
      : { position: -1, round_position: -1, price_change: -1, price: -1 };
  console.log("PLACINGS: ", placings);
  return (
    <div>
      <Loading isLoading={isloading === "loading"} setDone={setDone} />
      <PageContainer>
        <Header />
        {theTeam ? (
          <div
            style={{ display: "flex", flexDirection: "column", rowGap: "1rem" }}
          >
            <SingleSCTeamHeader
              team={theTeam}
              totalrank={lastplacing.position}
              rdrank={lastplacing.round_position}
              lastPlacing={lastplacing}
            />
            <RankGraph placings={placings} />
            <PlayerOwnershipsContainer
              playerOwnerships={playerOwnerships}
              placings={placings}
            />
          </div>
        ) : null}
      </PageContainer>
    </div>
  );
};

export default SingleSCTeam;
